/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import "../../virtualShop.css";

class VirtualShopMain extends Component {
    render() {
        return (<div className="cotvs_main">
            cotvs_main
        </div>)
    }
}
export default VirtualShopMain;